// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e2b81c5f","453":"0ac8dacb","732":"f20b6f60","977":"30265a3d"}[chunkId] + ".chunk.js";
};